import React, { FC } from 'react';
import styled from 'styled-components';

const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
`;

interface RowProps {
  children: React.ReactNode;
}

const Row: FC<RowProps> = ({ children }) => <StyledRow>{children}</StyledRow>;

export default Row;
